import React, { useEffect, useState } from 'react';

// Store
import { useSelector, useDispatch } from 'react-redux';
import { getAffiliateDetails } from 'store/actions/affiliates';

// Utils
import PropTypes from 'prop-types';

// Components
import SelectableProduct from 'components/Forms/SelectableProduct';

// Auth
import useAuthentication from 'utils/useAuthentication';
import { Button, Spacer, ContentBoxContainer, ContentBoxText, ProductBox  } from 'components';
import styled from '@emotion/styled';
import * as MediaQueries from 'utils/MediaQueries';
import getConfig from 'next/config';
import { mediaQueries, untilDesktopMediaQuery, untilMobileMediaQuery } from 'utils/MediaQueriesDeprecated';
import { renderKr } from 'utils/renderingService';
import JuraOrderForm from './JuraOrderForm';

const Circle = styled.div`
    position: absolute;
    top: -50px;
    right: -50px;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background-color: #0c3333; // Custom color for better contrast.
`;

const JuraSelectableProducts = ({ affiliateId, handleOrder, discountCode, circleElement }) => {
    const { publicRuntimeConfig } = getConfig();
    // Store
    const dispatch = useDispatch();
    const user = useSelector(state => state.user);
    const untilMobile = mediaQueries(untilMobileMediaQuery);
    const untilDesktop = mediaQueries(untilDesktopMediaQuery);
    // State
    const [productList, setProductList] = useState(null);
    const [productsSelected, setProductSelected] = useState([]);

    // Auth
    const { authenticated } = useAuthentication();

    const NoProductsSpacer = styled(Spacer)({
        display: 'none',
        [MediaQueries.TabletHorizontalOrLarger]: {
            display: 'block',
        },
    });
    const noProductsSelected = productsSelected.every(state => !state);
    const selectedProducts = productList?.filter((product, index) => productsSelected[index]);

    const handleProductClick = (index) =>{
        const newProductsSelected = [...productsSelected];
        newProductsSelected[index] = !newProductsSelected[index];
        setProductSelected(newProductsSelected);
    };
    const applyDiscount = (code, products) => {
        if(code === '9547'){
            const discounts = {
                'existing-testament':{ now: 0,  highlight: 'Gratis gennemgang' },
                'family-jura':{ now: 0,  highlight: 'Gratis gennemgang' },
                'new-testament':{ now: 4400, highlight: 'Normalpris 5500 kr.' },
                'prenuptial-agreement':{ now: 4400, highlight: 'Normalpris 5500 kr.' },
                'power-of-attorney':{ now: 2000, highlight: 'Normalpris 2.500 kr.' },

            };
            return products.map(p => ({ ...p, price: { ...p.price, now:discounts[p.id].now }, highlight:discounts[p.id].highlight } ));
        }
        if(code === '7629'){
            const discounts = {
                'existing-testament':{ now: 0,  highlight: 'Gratis gennemgang' },
                'family-jura':{ now: 0,  highlight: 'Gratis gennemgang' },
                'new-testament':{ now: 3750, highlight: 'Normalpris 5.625 kr.' },
                'prenuptial-agreement':{ now: 3750, highlight: 'Normalpris 5.625 kr.' },
                'power-of-attorney':{ now: 1500, highlight: 'Normalpris 2.500 kr.' },

            };
            return products.map(p => ({ ...p, price: { ...p.price, now:discounts[p.id].now }, highlight:discounts[p.id].highlight } ));
        }
        return products;
    };
    useEffect(() => {
        (async () => {
            let affiliate = await dispatch(getAffiliateDetails(affiliateId));
            let productsWithDiscount = applyDiscount(discountCode, Object.values(affiliate.products).filter(p => !p.hidden && p.categories.find((c) => c === 'law')));
            if(!productsWithDiscount.length){
                affiliate = await dispatch(getAffiliateDetails('alliance-advokater'));
                productsWithDiscount = applyDiscount(discountCode, Object.values(affiliate.products).filter(p => !p.hidden && p.categories.find((c) => c === 'law')));

            }
            if (affiliate) {
                setProductList(productsWithDiscount);
                setProductSelected(Array(productList?.length).fill(false));
            }
        })();
    }, [user, authenticated, dispatch, affiliateId]);

    const sumProductPrices = (products) => products.map(x => x.price?.now || x.price?.standard || 0).reduce((partialSum, a) => partialSum + a, 0);
    return (
        <>
            <div style={{ position: 'relative' }}>
                <div className="productBoxes" style={{ position: 'relative' }}>
                    { productList &&
                    productList.map((product, index) =>
                        <SelectableProduct
                            product={ product }
                            elementId={ product.id }
                            key={ product.id }
                            chooseProductFunc={ () => handleProductClick(index) }
                            selected={ productsSelected[index] }
                            priceSuffix={ (product.id === 'existing-testament' || product.id === 'family-jura') ? '' : '*' }
                        />,
                    )
                    }

                </div>
                <div> { circleElement && circleElement }</div>
            </div>
            <div style={{ width:'100%', display: 'flex', justifyContent: 'center', marginTop:40 }}>
                { !noProductsSelected &&
                    <>
                        { publicRuntimeConfig.featurePensionCheckNewOrderFlow?

                            <div style={{ width:'100%', maxWidth: '1042px'  }}>
                                <article style={{ textAlign: 'center', paddingBottom: 0, paddingTop:20, backgroundColor: '#EEEEEE' }}>
                                    <h2 style={{ marginBottom: 0, marginTop: 20 }}>BESTIL JURIDISK RÅDGIVNING</h2>
                                </article>
                                <ContentBoxContainer className="mobileflip brbr " style={{ paddingTop: 0, backgroundColor: '#EEEEEE', marginBottom:46 }}>
                                    <ContentBoxText id="order" className="" style={{ paddingTop: 44, width:'unset' }}>
                                        <JuraOrderForm handleOrder={ (customer) => handleOrder(selectedProducts, productList, customer) } selectedProducts={ selectedProducts }></JuraOrderForm>
                                    </ContentBoxText>
                                    <ContentBoxText style={{ paddingTop: 44, paddingBottom: 0 }}>
                                        <div style={{ height: '80%', display: 'flex', justifyContent: 'flex-start', marginBottom: untilMobile ? -20 : 40 }} className="productBoxes">
                                            <div id={ 'law-products-selected'  } style={{ minHeight:438 }}>
                                                <div>
                                                    <div className="title">
                                                        <h5>JURIDISK RÅDGIVNING</h5>
                                                    </div>
                                                    <div className="price">
                                                        <div>
                                                            <>
                                                                { renderKr(sumProductPrices(selectedProducts), '', 1) }
                                                                <span>
                                                                    kr. <span style={{ fontSize: '15px' }}></span>
                                                                </span>
                                                            </>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <strong className="highlight">
                                                            Uvildig juridisk rådgivning
                                                        </strong>
                                                    </div>

                                                    <div className="productInfoTitle" style={{ marginBottom:0 }}> Du har valgt:
                                                    </div>
                                                    <div className="focusTextWhite">
                                                        <ul>
                                                            { selectedProducts.map(x => <li style={{ padding:'0 0 0 20px' }}>{ x.name }</li>) }
                                                        </ul>
                                                    </div>
                                                </div>



                                            </div>
                                        </div>
                                    </ContentBoxText>
                                </ContentBoxContainer>
                            </div>:

                            <Button size="large" onClick={ () => handleOrder(selectedProducts, productList) } >{ selectedProducts.filter(x => x).length > 1 ? <>Bestil produkter</> : <>Bestil produkt</> }</Button>

                        }

                        <NoProductsSpacer size="medium" />
                    </>
                }
            </div>
        </>
    );
};

JuraSelectableProducts.propTypes = {
    chooseProductFunc: PropTypes.func,
    chooseProductText: PropTypes.string,
    affiliateId: PropTypes.string,
    handleOrder: PropTypes.func,
    discountCode: PropTypes.string,
    circleElement: PropTypes.node,
};

export default JuraSelectableProducts;
